enum InventoryGroupTypes {
  Physical = 'physical',
  Online = 'online'
};

export default InventoryGroupTypes;
